import { QUALITY, LIFESTYLE } from "@/data/products";
import { ShieldCheck } from "lucide-react";

export default function Quality() {
  return (
    <div data-testid="quality-page">
      <section className="relative pt-20 pb-24 bg-neutral-950 text-white overflow-hidden">
        <div className="absolute inset-0 opacity-30">
          <img src={LIFESTYLE.lab} alt="" className="w-full h-full object-cover" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-neutral-950/40 to-neutral-950" />
        <div className="relative max-w-5xl mx-auto px-6">
          <div className="eyebrow text-gold-400 mb-4">Quality Assurance</div>
          <h1 className="font-display font-bold text-5xl lg:text-7xl tracking-tighter leading-[0.95]">
            World-class quality.<br /><span className="gold-gradient-text">Every batch. Every bottle.</span>
          </h1>
          <p className="mt-6 text-lg text-neutral-300 max-w-2xl leading-relaxed">
            Our quality programmes align with international food-safety and manufacturing standards. Every SBC product is engineered, tested and traced to the highest global benchmarks.
          </p>
        </div>
      </section>

      <section className="py-24 bg-background">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {QUALITY.map((q) => (
            <div key={q.title} className="p-6 rounded-2xl border border-border hover:border-gold-400 transition-colors">
              <div className="w-10 h-10 rounded-full bg-gold-400/15 flex items-center justify-center mb-4">
                <ShieldCheck className="w-5 h-5 text-gold-500" />
              </div>
              <div className="font-display font-bold text-xl">{q.title}</div>
              <p className="text-sm text-muted-foreground mt-2 leading-relaxed">{q.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="py-24 bg-muted/40">
        <div className="max-w-6xl mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center">
          <img src={LIFESTYLE.bottling} alt="" className="rounded-3xl w-full aspect-[4/3] object-cover shadow-lg" />
          <div className="space-y-6">
            <div className="eyebrow">Standards</div>
            <h2 className="font-display font-bold text-4xl tracking-tighter">Certified. Audited. Trusted.</h2>
            <ul className="space-y-3 text-sm">
              {["FSSC 22000 aligned production", "ISO 9001 quality management", "HACCP food-safety systems", "Halal certified portfolio", "Independent laboratory verification"].map((x) => (
                <li key={x} className="flex items-center gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-gold-400" />
                  {x}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}
